export default __webpack_public_path__ + "static/media/shopee_bg.3d2acc65.webp";